


























import Vue from 'vue';

export default Vue.extend({
    name: 'TextArea',
    props: {
        value: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: null,
        },
        helperText: {
            type: String,
            default: null,
        },
        color: {
            type: String,
            default: null,
        },
        outline: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        listeners(): object {
            return {
                ...this.$listeners,
                input: this.handleChange,
                keydown: this.handleKeyDown,
            };
        },
    },
    methods: {
        focus() {
            (this.$refs.textarea as HTMLTextAreaElement).focus();
        },
        handleChange(event: Event) {
            this.$emit('input', (event.target as HTMLTextAreaElement).value);
        },
        handleKeyDown(event: KeyboardEvent) {
            if (event.ctrlKey && event.key === 'Enter') this.$emit('ctrlEnter', event);
        },
    },
});
